import axios from "axios";

// API base URL — empty = relative paths, React dev-server proxy forwards /api/* to backend
const API_BASE_URL = process.env.REACT_APP_API_URL || "";
console.log("API BASE URL =", API_BASE_URL || "(proxy)");

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 300000,
});

/* ================================
   Request Interceptor
================================ */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);
/* ================================
   Utility Functions
================================ */
// Convert PascalCase keys to camelCase recursively
const toCamelCase = (obj) => {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(toCamelCase);
  
  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
    acc[camelKey] = toCamelCase(obj[key]);
    return acc;
  }, {});
};

/* ================================
   Response Interceptor
================================ */
api.interceptors.response.use(
  (response) => {
    // Convert PascalCase to camelCase for all responses
    if (response.data) {
      response.data = toCamelCase(response.data);
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;

    console.error("API Error:", {
      message: error.message,
      status,
      url: error.config?.url,
    });

    // 401 - Unauthorized
    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    // 403 - Forbidden
    if (status === 403) {
      console.error("Access denied");
    }

    // Network / CORS / Server down
    if (!error.response) {
      console.error("Network error or server not reachable");
    }

    return Promise.reject(error);
  }
);

export default api;